import React from 'react';
import Outsourced from '../../../../forms/outsourced';
import CreateUpdateForm from '../../../../components/createUpdateForm';
import restApiClient from '../../../../services/restApiClient';
import { Container } from './styles';
import { objectMap } from '../../../../extensions/object';
import { isEqualWith } from 'lodash';

function OutsourcedCreateUpdate(props) {
  return (
    <Container>
      <CreateUpdateForm
        modelSchema={Outsourced}
        restGetDataById={ async (id) => {
          const result = await restApiClient.outsourced.findById(id);
          result.data = objectMap(result.data, (key, value) => { 
            if(value === null) return undefined;
            return value;
          })
          return result;
        }}
        restCreateData={restApiClient.outsourced.create}
        restUpdateData={ async (modelId, updateOriginalData, modelData) => {
          
          const added = modelData.outsourcedBankAccounts.filter(
            item => !updateOriginalData.outsourcedBankAccounts.some(obj => 
              isEqualWith(obj, item, (obj1, obj2) => 
                obj1.account === obj2.account &&
                obj1.accountDigit === obj2.accountDigit &&
                obj1.agency === obj2.agency &&
                obj1.agencyDigit === obj2.agencyDigit &&
                obj1.bank === obj2.bank
              )
            )
          );
          
          const removed = updateOriginalData.outsourcedBankAccounts.filter(
            item => !modelData.outsourcedBankAccounts.some(obj =>
              isEqualWith(obj, item, (obj1, obj2) =>
                obj1.account === obj2.account &&
                obj1.accountDigit === obj2.accountDigit &&
                obj1.agency === obj2.agency &&
                obj1.agencyDigit === obj2.agencyDigit &&
                obj1.bank === obj2.bank
              )
            )
          ).map(item => item.id);
          delete modelData.outsourcedBankAccounts;
          delete updateOriginalData.outsourcedBankAccounts;
          const result = await restApiClient.outsourced.update(
            modelId, updateOriginalData, modelData, added, removed);
          return result;
        }}
        onCreateSuccess={(request) => {
          props.history.goBack();
        }}
        onUpdateSuccess={(request) => {
          props.history.goBack();
        }}
        {...props}
      />
    </Container>
  );
}

export default OutsourcedCreateUpdate;
